import React from "react";
import "./index.css";

interface PlaceholderStateProps {
  icon?: string;
  title: string;
  subtitle?: string;
  onAction?: () => void;
  actionText?: string;
  showSpinner?: boolean;
  isError?: boolean;
}

export const PlaceholderState: React.FC<PlaceholderStateProps> = ({
  icon,
  title,
  subtitle,
  onAction,
  actionText,
  showSpinner = false,
  isError = false,
}) => {
  return (
    <div className={`packs-placeholder ${isError ? "packs-placeholder--error" : ""}`}>
      {showSpinner ? (
        <div className="packs-spinner" />
      ) : icon && (
        <div className="packs-placeholder__icon">{icon}</div>
      )}
      <p className="packs-placeholder__title">{title}</p>
      {subtitle && <p className="packs-placeholder__sub">{subtitle}</p>}
      {onAction && actionText && (
        <button className="packs-load-btn" onClick={onAction}>
          {actionText}
        </button>
      )}
    </div>
  );
};